<svg
  width="18"
  height="18"
  viewBox="0 0 18 18"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...$$props}
>
  <g id="v01-03 1">
    <g id="Group">
      <path
        id="Vector"
        d="M14.3181 8.52376C14.2656 8.52376 14.2094 8.53126 14.1569 8.53126C13.5044 8.53126 12.8481 8.22751 12.4506 7.63501C11.6594 8.82001 9.83313 8.82001 9.04188 7.63501C8.24688 8.82001 6.42438 8.82001 5.63313 7.63501C5.23563 8.22751 4.57938 8.53126 3.92688 8.53126C3.87438 8.53126 3.81813 8.52751 3.76563 8.52376C3.63813 8.51626 3.51438 8.49376 3.39062 8.46001V15.0713H4.98063V10.08C4.98063 9.97501 5.06313 9.89251 5.16813 9.89251H8.19063C8.29563 9.89251 8.37813 9.97501 8.37813 10.08V15.0713H14.6931V8.46001C14.5694 8.49376 14.4456 8.51626 14.3181 8.52376ZM9.90813 10.08C9.90813 9.97501 9.99063 9.89251 10.0956 9.89251H12.7581C12.8631 9.89251 12.9456 9.97501 12.9456 10.08V12.6263C12.9456 12.7313 12.8631 12.8138 12.7581 12.8138H10.0956C9.99063 12.8138 9.90813 12.7313 9.90813 12.6263V10.08Z"
        fill="white"
      />
      <path
        id="Vector_2"
        d="M14.6931 8.46004C14.5694 8.49379 14.4456 8.51629 14.3181 8.52379V14.58H8.37813V15.4463H14.6931C14.8994 15.4463 15.0681 15.2513 15.0681 15.0113V8.32129C14.9481 8.38129 14.8206 8.42629 14.6931 8.46004ZM3.76562 14.58V8.52379C3.63813 8.51629 3.51438 8.49379 3.39062 8.46004C3.26313 8.42629 3.13562 8.38129 3.01562 8.32129V15.0113C3.01562 15.2513 3.18437 15.4463 3.39062 15.4463H4.98062V14.58H3.76562Z"
        fill="white"
      />
    </g>
    <path
      id="Vector_3"
      d="M2.02539 5.25H5.52039C5.45289 7.90125 2.07789 7.88625 2.02539 5.25Z"
      fill="white"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Vector_4"
      d="M5.52734 5.25H8.92109C8.87234 7.87125 5.57609 7.87125 5.52734 5.25Z"
      fill="white"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Vector_5"
      d="M8.92969 5.25H12.3759C12.3234 7.89375 8.98219 7.89375 8.92969 5.25Z"
      fill="white"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Vector_6"
      d="M15.4134 3.62745H2.64844L5.34094 1.2312H12.7247L15.4134 3.62745Z"
      fill="white"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Vector_7"
      d="M16.0541 5.25C15.9978 7.89375 12.4391 7.89375 12.3828 5.25H16.0541Z"
      fill="white"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      id="Vector_8"
      d="M5.52328 5.56873C5.52328 5.59123 5.52328 5.61373 5.52703 5.63248H5.51953C5.51953 5.63248 5.52328 5.59123 5.52328 5.56873Z"
      fill="white"
    />
    <path
      id="Vector_9"
      d="M8.92562 5.56873C8.92562 5.59123 8.92562 5.61373 8.92937 5.63248H8.92188C8.92188 5.63248 8.92562 5.59123 8.92562 5.56873Z"
      fill="white"
    />
    <path
      id="Vector_10"
      d="M12.3825 5.63248H12.375C12.375 5.63248 12.3787 5.59123 12.3787 5.56873C12.3787 5.59123 12.3788 5.61373 12.3825 5.63248Z"
      fill="white"
    />
  </g>
</svg>
